import {CatalogReference} from '@wix/auto_sdk_ecom_current-cart';

export class CatalogReferenceModel {
  public catalogItemId: string;
  public appId: string;

  constructor(params: CatalogReferenceModel) {
    this.catalogItemId = params.catalogItemId;
    this.appId = params.appId;
  }

  public static fromCartV1(catalogReference: CatalogReference) {
    return new CatalogReferenceModel({
      catalogItemId: catalogReference?.catalogItemId,
      appId: catalogReference?.appId,
    });
  }
}
